import {
  widths as supportedWidths,
  createImageUrl
} from '@nrk/serum-imagecrop-utils'
import { getPositionClasses } from '../../utils/alignment-classes'

export function createSrcSet(imageId, ratio, supportedWidths) {
  return supportedWidths.map((width) => {
    const imageUrl = createImageUrl({id: imageId, width, ratio})
    return `${imageUrl} ${width}w`
  }).join(', ')
}

export const polopolyIdHandler = {
  property: 'data-background-polopoly-id',
  load: (card) => {
    const polopolyId = card.getAttribute('data-background-polopoly-id')

    const elem = document.createElement('div')
    const defaultUrl = createImageUrl({id: polopolyId, width: 1600, ratio: '1:1'})
    const desktopSourceSet = createSrcSet(polopolyId, '1:1', supportedWidths)
    const mobileSourceSet = createSrcSet(polopolyId, '3:4', supportedWidths)

    
    const imgStyle = card.getAttribute('data-align-top') ? 
      "min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, 0%, 0); top: 0%;" : 
      "min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, -50%, 0); top: 50%;"


    elem.innerHTML = `
      <picture style="object-fit: cover;">
      <source media="(min-aspect-ratio: 3/4)" srcset="${desktopSourceSet}">
      <img src="${defaultUrl}" srcset="${mobileSourceSet}" style="${imgStyle}">
      </picture>
    `
    elem.id = card.getAttribute('data-background-id')

    return elem
  }
}



// WEBPACK FOOTER //
// ./src/client/sections/polopoly-image/index.js